import React from 'react'
import styled from 'styled-components'
import Flex from 'components/reusable/flex'
import Text from 'components/reusable/text'
import SvgCheckSolid from 'components/reusable/svg/referrals/svg_check_solid'
import SvgCrossSolid from 'components/reusable/svg/referrals/svg_cross_solid'
import useReferralTimelineSteps from './use_referral_timeline_steps'
import { colors } from 'helpers/colors'
import { noSelect } from 'helpers/style'

const TimelineContainer = styled.div`
  width: 100%;
  ${noSelect}
`

const TimelineItem = styled(Flex)`
  position: relative;
  padding-left: 40px;
  padding-bottom: 24px;

  &:last-child {
    padding-bottom: 0;
  }

  &:not(:last-child)::before {
    content: '';
    position: absolute;
    left: 12px;
    top: 30px;
    bottom: 4px;
    width: 2px;
    background: ${({ $isCompleted }) => $isCompleted ? colors.secondary[500] : colors.gray[200]};
  }
`

const StepCircle = styled(Flex)`
  position: absolute;
  left: 0;
  top: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  line-height: 13px;
  border: 2px solid ${({ $isCompleted, $isNext, $isFailed }) => 
    $isFailed ? colors.primary[500] : 
    ($isCompleted || $isNext) ? colors.secondary[500] : colors.gray[200]};
  background: ${({ $isCompleted, $isFailed }) => 
    $isFailed ? colors.primary[500] : 
    $isCompleted ? colors.secondary[500] : colors.light};
  color: ${({ $isCompleted }) => $isCompleted ? colors.light : colors.gray[700]};
`

function TimelineStepRow({ step }) {
  return (
    <TimelineItem dir="column" ai="flex-start" jc="flex-start" gap={4} $isCompleted={step.isCompleted}>
      <StepCircle $isCompleted={step.isCompleted} $isNext={step.isNext} $isFailed={step.isFailed} ai="center" jc="center">
        {step.isCompleted
          ? (step.isFailed
            ? <SvgCrossSolid size={16} color={colors.light} />
            : <SvgCheckSolid size={16} color={colors.light} />)
          : <Text size={12} color={colors.gray[700]}>{step.index}</Text>}
      </StepCircle>

      <Flex ai="center" gap={8}>
        <Text size={16} weight={500}>{step.title}</Text>
        {step.isCompleted && step.date ? (
          <Text size={14} color={colors.gray[400]}>• {step.date}</Text>
        ) : (
          <Text size={14} color={colors.gray[400]}>• pending</Text>
        )}
      </Flex>

      <Text size={14} color={colors.gray[400]} lineHeight="140%">
        {step.description}
      </Text>
    </TimelineItem>
  )
}

function ReferralTimeline({ ledger = [] }) {
  const stepsWithStatus = useReferralTimelineSteps(ledger)

  return (
    <TimelineContainer>
      {stepsWithStatus.map((step) => (
        <TimelineStepRow key={step.key} step={step} />
      ))}
    </TimelineContainer>
  )
}

export default ReferralTimeline
